var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7352 2.69861H7.68561V0.724609H5.68561V2.69861H2.60199C1.49742 2.69861 0.60199 3.59404 0.60199 4.69861V26.8345C0.60199 27.9391 1.49742 28.8345 2.60199 28.8345H26.602C27.7066 28.8345 28.602 27.9391 28.602 26.8345V4.69861C28.602 3.59404 27.7066 2.69861 26.602 2.69861H23.7352V1.0058L21.7352 1.0058V2.69861ZM2.60199 4.69861H26.602V7.95935H2.60199V4.69861ZM2.60199 9.95935V26.8345H26.602V9.95935H2.60199Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeet);
export default __webpack_public_path__ + "static/media/meet.7c8b904db54f60df20163671cd724d45.svg";
export { ForwardRef as ReactComponent };